import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  getCycleListFactorByDate(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbanadjust/getcyclelistfactorbydate', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getCycleListByBetweenDate(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbanadjust/getcyclelistfactorbybetweendate', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPartlinkage(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbanadjust/getpartlinkage', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPartlinkageDetail(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbanadjust/getpartlinkagedetail', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getKanbanAdjustList(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbanadjust/getkanbanadjustlist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addKanbanAdjustFactor(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'kanbanadjust/addfactor', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  rmKanbanAdjust(URL, header, success, error) {
    Vue.axios.delete(URL + 'kanbanadjust/removekanbanadjust', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  rmKanbanAdjustList(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'kanbanadjust/cancelkanbanadjustlist', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getKanbanAdjustListById(URL, header, success, error) {
    Vue.axios.get(URL + 'kanbanadjust/getkanbanadjustbyid', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  checkAdjust(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'kanbanadjust/checkadjust', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  createAdjust(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'kanbanadjust/createadjust', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDockBySpl (URL, header, success, error) {
    Vue.axios.get(URL + 'getref/dockbyspl', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSupplierByDk (URL, header, success, error) {
    Vue.axios.get(URL + 'getref/supplierbydk', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPartByDkSpl (URL, header, success, error) {
    Vue.axios.get(URL + 'getref/partbydkspl', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
  //   approveAdjust (URL, obj, header, success, error) {
  //     Vue.axios.post(URL + 'adjust/approve', obj, header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   addAdj (URL, obj, header, success, error) {
  //     Vue.axios.post(URL + 'adjust', obj, header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   editAdj (URL, obj, header, success, error) {
  //     Vue.axios.put(URL + 'adjust', obj, header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   rmAdjustDetail (URL, header, success, error) {
  //     Vue.axios.delete(URL + 'adjust/detail', header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   exportDatas (URL, header, success, error) {
  //     Vue.axios.get(URL + 'adjust/export', header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   }
}



// WEBPACK FOOTER //
// ./src/models/KanbanAdjust.js